<template>
    <div class="modal-overlay" @click.self="fechar">
      <div class="modal-content">
        <header class="modal-header">
          <!-- Título do modal com o nome do aluno -->
          <h6>Observações do Aluno: {{ aluno.aluno_nome }}</h6>
        </header>
        <section class="modal-body">
          <div class="modal-table-scroll">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Data</th>
                  <th>Observação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(obs, index) in observacoes" :key="obs.id">
                  <td>{{ index + 1 }}</td>
                  <td>
                    {{ (obs.data_observacao && globalUtils.formatarData(obs.data_observacao)) || 'N/A' }}
                  </td>
                  <td v-if="obs.falta_avisada" style="color: blue;">
                    {{ 'Falta avisada para o dia ' + (obs.data_falta ? globalUtils.formatarData(obs.data_falta) : 'N/A') + ' - ' + obs.observacao }}
                  </td>
                  <td v-else :style="obs.observacao.includes('Queda') ? 'color: red;' : ''">
                    {{ obs.observacao }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
        <footer class="modal-footer">
          <button class="btn btn-secondary" @click="fechar">Fechar</button>
        </footer>
      </div>
    </div>
  </template>
  
  <script setup>
  import { toRefs } from 'vue';
  import globalUtils from '@/utils/globalUtils';
  
  const props = defineProps({
    aluno: {
        type: Object,
        required: true
    },
    observacoes: {
        type: Array,
        required: true
    }
  });

  const { aluno, observacoes } = toRefs(props);
  
  const emit = defineEmits(['fechar']);
  
  function fechar() {
    emit('fechar');
  }
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    width: 90%;
    max-width: 65%;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }
  
  .modal-header {
    margin-bottom: 1rem;
  }
  
  .modal-body {
    margin-bottom: 1rem;
  }
  
  .modal-footer {
    text-align: right;
  }
  
  .modal-table-scroll {
    max-height: 400px;
    overflow-y: auto;
  }
  </style>
  